// extracted by mini-css-extract-plugin
export var linkText = "_op-0";